<template>
  <div class="rigth_Infwarp">
    <el-card style="height:100%">
      <p>人口自然增长率对比</p>
      <div class="infro" ref="MyEcharts"></div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let myehcarts = this.$echarts.init(this.$refs.MyEcharts);
      let option = {
        // title: {
        //   text: "堆叠区域图",
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["邮件营销", "联盟广告", "视频广告", "直接访问", "搜索引擎"],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "2020年第三季度",
              "2020年第四季度",
              "2021年第一季度",
              "2021年第二季度",
            ],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "邮件营销",
            type: "line",
            stack: "总量",
            smooth: true,
            showSymbol: false,
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [120, 132, 101, 134],
            markLine: {
              data: [
                {
                  type: "average",
                  name: "平均值",
                  label: {
                    formatter: (data) => {
                      return data.name + ":" + data.value;
                    },
                    textStyle: {
                      color: "#FF0000",
                    },
                  },
                },
              ],
            },
          },
        ],
      };
      myehcarts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.rigth_Infwarp {
  height: 500px;
  margin: 10px 0;
  .el-card__body {
    height: 100%;
    .infro {
      height: 90%;
    }
  }
}
</style>
